import { mergeStyles } from "@fluentui/merge-styles";
import { LINK_COLOR } from "../../../../config/colors";

export const sectionLinkClass = mergeStyles({
  color: "#000",
  textDecoration: "none",

  "&:hover": {
    color: LINK_COLOR,
  },
});

export const sectionWrapperClass = mergeStyles({
  position: "relative",
});
export const sectionTitleClass = mergeStyles({
  position: "relative",
  padding: "3px 5px",
});
export const progressWrapperClass = mergeStyles({
  position: "absolute",
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  display: "flex",
});
export const progressBarClass = mergeStyles({
  height: "100%",
  width: 0,
  transition: "2s",
});
